import { SvgIcon, SvgIconProps } from '@mui/material'

const Wallet = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 29 29" fill="none">
        <path
            d="M25.5821 11.0417C25.4882 8.7793 25.1852 7.3922 24.2087 6.41565C22.7931 5 20.5145 5 15.9577 5H12.3327C7.77577 5 5.49732 5 4.08166 6.41565C2.66602 7.83131 2.66602 10.1098 2.66602 14.6667C2.66602 19.2235 2.66602 21.5021 4.08166 22.9177C5.49732 24.3333 7.77577 24.3333 12.3327 24.3333H15.9577C20.5145 24.3333 22.7931 24.3333 24.2087 22.9177C25.1852 21.9412 25.4882 20.554 25.5821 18.2917"
            fill="none"
            stroke="#1C60AB"
            strokeWidth="1.8125"
        />
        <path
            d="M7.49414 9.8335H12.3275"
            fill="none"
            stroke="#1C60AB"
            strokeWidth="1.8125"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M25.4177 11.042H22.273C20.117 11.042 18.3691 12.6649 18.3691 14.667C18.3691 16.6691 20.117 18.292 22.273 18.292H25.4177C25.5185 18.292 25.5688 18.292 25.6113 18.2895C26.2629 18.2497 26.7819 17.7678 26.8247 17.1627C26.8275 17.1232 26.8275 17.0764 26.8275 16.983V12.351C26.8275 12.2576 26.8275 12.2108 26.8247 12.1713C26.7819 11.5662 26.2629 11.0842 25.6113 11.0446C25.5688 11.042 25.5185 11.042 25.4177 11.042Z"
            fill="none"
            stroke="#E7C900"
            strokeWidth="1.8125"
        />
        <path
            d="M21.9824 14.6675H21.9937"
            fill="none"
            stroke="#E7C900"
            strokeWidth="2.41667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
)

export default Wallet
